export default __webpack_public_path__ + "static/media/Vaccine.630c4435.png";